var _excluded = ["backgroundImage", "logo", "textBox", "label", "title", "description", "hasHover"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { forwardRef } from "react";
import styled, { css } from "styled-components";
import useBreakpoint from "../../../../hooks/useBreakpoint";
import isNotEmpty from "../../../../utils/isNotEmpty";
import space from "../../../../utils/space";
import transition from "../../../../utils/transition";
import LabelAtm from "../../../atoms/LabelAtm";
import { labelSizes, labelTypography } from "../../../atoms/LabelAtm/LabelAtm.config";
import LogoBoxAtm, { logoBoxAtmSizes } from "../../../atoms/LogoBoxAtm";
import TextAtm from "../../../atoms/TextAtm";
import TextBoxAtm from "../../../atoms/TextBoxAtm";
import Picture from "../../../quarks/Picture";
import { largeBreakpointValue, paddingSpace } from "../AdvancedProductCardMol.settings";
var logoBoxSize = "small";
var labelAtmSize = "default";
var labelGutterSpace = 1;
var Header = styled.header.withConfig({
  componentId: "sc-1kp0ura-0"
})(["margin-bottom:", ";"], space(2));
var HeaderBackground = styled.div.withConfig({
  componentId: "sc-1kp0ura-1"
})(["width:calc(100% + ", ");height:", ";margin:", " ", " 0 ", ";overflow:hidden;"], space(2 * paddingSpace), space(10), space(-1 * paddingSpace), space(-1 * paddingSpace), space(-1 * paddingSpace));
var HeaderBackgroundImage = styled(Picture).withConfig({
  componentId: "sc-1kp0ura-2"
})(function (_ref) {
  var $hasHoverOnMobile = _ref.$hasHoverOnMobile;
  return css(["", ";width:100%;height:100%;object-fit:cover;", ""], transition("transform"), $hasHoverOnMobile && css(["transform:scale(1.2);"]));
});
var HeaderLogoContainer = styled.div.withConfig({
  componentId: "sc-1kp0ura-3"
})(function (_ref2) {
  var theme = _ref2.theme,
    $hasLogo = _ref2.$hasLogo;
  var logoBoxHeightSpace = logoBoxAtmSizes[logoBoxSize].boxSizeSpace;
  var labelAtmPaddingSpace = labelSizes[labelAtmSize].paddingSpace;
  var labelAtmLineHeightSpace = theme.typography[labelTypography].lineHeightSpace;
  var labelAtmHeightSpace;
  if (typeof labelAtmPaddingSpace === "number") {
    labelAtmHeightSpace = 2 * labelAtmPaddingSpace + labelAtmLineHeightSpace;
  } else {
    labelAtmHeightSpace = 2 * labelAtmPaddingSpace.y + labelAtmLineHeightSpace;
  }
  return css(["display:flex;position:relative;align-items:flex-end;justify-content:space-between;margin-top:", ";margin-bottom:", ";"], $hasLogo ? space(-1 * logoBoxHeightSpace + labelAtmHeightSpace + labelGutterSpace) : 0, space(1.5));
});
var MainContent = /*#__PURE__*/forwardRef(function (_ref3, ref) {
  var backgroundImage = _ref3.backgroundImage,
    logo = _ref3.logo,
    textBox = _ref3.textBox,
    label = _ref3.label,
    title = _ref3.title,
    description = _ref3.description,
    hasHover = _ref3.hasHover,
    restProps = _objectWithoutProperties(_ref3, _excluded);
  var isBiggerScreen = useBreakpoint(largeBreakpointValue);
  return /*#__PURE__*/React.createElement("div", _extends({
    ref: ref
  }, restProps), /*#__PURE__*/React.createElement(Header, null, /*#__PURE__*/React.createElement(HeaderBackground, null, /*#__PURE__*/React.createElement(HeaderBackgroundImage, {
    srcData: backgroundImage,
    alt: backgroundImage.alt,
    $hasHoverOnMobile: !!hasHover && !isBiggerScreen
  })), /*#__PURE__*/React.createElement(HeaderLogoContainer, {
    $hasLogo: !!logo || !!textBox
  }, logo ? /*#__PURE__*/React.createElement(LogoBoxAtm, _extends({}, logo, {
    size: logoBoxSize
  })) : null, textBox ? /*#__PURE__*/React.createElement(TextBoxAtm, _extends({}, textBox, {
    size: logoBoxSize
  })) : null, isNotEmpty(label) ? /*#__PURE__*/React.createElement(LabelAtm, {
    size: labelAtmSize,
    variant: label.variant || "notify",
    emphasis: label.emphasis
  }, label.children) : null), /*#__PURE__*/React.createElement(TextAtm, {
    typography: "big3"
  }, title)), /*#__PURE__*/React.createElement(TextAtm, {
    typography: "tiny1",
    emphasis: "medium",
    pushSpace: 2
  }, description));
});
export default MainContent;